var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"title_tip",class:{'en-title-tip': _vm.getLang() === 'en'},attrs:{"href":"https://help.westartrack.com/faq/d_5da9770d4db67f2b542982bc.html","target":"_blank"}},[_c('i',{staticClass:"iconfont iconicon-test68"}),_vm._v("\n  "+_vm._s(_vm.$t('message["1247"]'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }